// extracted by mini-css-extract-plugin
module.exports = {"textContainer":"ShO7LYn-gE0U1pK728F4NQ==","componentContainer":"FKH2vldfPaZX2ukH8ugabA=="};